export default __webpack_public_path__ + "static/media/au_pfln.392cbc25.jpg";